// extracted by mini-css-extract-plugin
export var WorkingDayBackground = "SectorPage-module--WorkingDayBackground--ebf45";
export var blogHeaderSection = "SectorPage-module--blogHeaderSection--ac276";
export var imageTextSectionHeader = "SectorPage-module--imageTextSectionHeader--ab6d8";
export var sectorWrapper = "SectorPage-module--sectorWrapper--41cad";
export var sliderSection = "SectorPage-module--sliderSection--6ce74";
export var videoBlock = "SectorPage-module--videoBlock--90450";